import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

export interface IPermissionDetails {
	type: string;
	data: any;
}
export interface IPermissionsModuleState {
	permissionRoleDrawer: boolean;
	permissionGroupDrawer: boolean;
	roleDetails: IPermissionDetails;
	groupDetails: IPermissionDetails;
}

const initialState: IPermissionsModuleState = {
	permissionRoleDrawer: false,
	permissionGroupDrawer: false,
	roleDetails: { type: '', data: {} },
	groupDetails: { type: '', data: {} },
};

export const permissionsSlice = createSlice({
	name: 'permissionsmodule',
	initialState,
	reducers: {
		setRolePermissionDrawer: (state, action: PayloadAction<boolean>) => {
			state.permissionRoleDrawer = action.payload;
		},
		setGroupPermissionDrawer: (state, action: PayloadAction<boolean>) => {
			state.permissionGroupDrawer = action.payload;
		},
		setRoleDetails: (state, action: PayloadAction<IPermissionDetails>) => {
			state.roleDetails = action.payload;
		},
		setGroupDetails: (state, action: PayloadAction<IPermissionDetails>) => {
			state.groupDetails = action.payload;
		},
	},
});

export const {
	setRolePermissionDrawer,
	setGroupPermissionDrawer,
	setRoleDetails,
	setGroupDetails,
} = permissionsSlice.actions;
export default permissionsSlice.reducer;
